import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=299128c5"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('299128c5')) {
      api.createRecord('299128c5', component.options)
    } else {
      api.reload('299128c5', component.options)
    }
    module.hot.accept("./Setting.vue?vue&type=template&id=299128c5", function () {
      api.rerender('299128c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/Index/Setting.vue"
export default component.exports